import React from 'react'
import TrueFalseDataTest from '../components/test/TrueFalseDataTest'

const TrueFalseDataTestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <TrueFalseDataTest />
    </div>
  )
}

export default TrueFalseDataTestPage